import { FaRegCalendar } from "react-icons/fa";
import { Link } from "react-router-dom";
import styled from "styled-components";
import Table from "../../sharedComponents/Table";
import useIsMobileView from "../../../hooks/useIsMobileView";
import DisplayAndAddMultiConsultNotes from "./DisplayAndAddMultiConsultNotes";
import { formatDateSpan } from "../../../utils";

const EventLink = styled(Link)`
  color: rgb(2, 128, 198);

  &:visited {
    color: rgb(2, 128, 198);
  }
`

const CenteredColumn = styled.div`
  display: flex;
  justify-content: center;
`

export default ({
  events,
}) => {
  const isMobileView = useIsMobileView();

  const columns = [
    {
      field: 'name',
      title: 'Event',
      renderer: (data = {}) => {
        const { id, name } = data
        return (
          <EventLink to={`/home/event?id=${id}`} target="_blank" rel="noopener noreferrer">
            {name}
          </EventLink>
        )
      }
    },
    {
      field: 'startDate',
      title: 'Dates',
      renderer: (data = {}) => {
        const { startDate, endDate } = data;
        return startDate && endDate ? (
          <div style={{
            flex: 1,
            fontWeight: 'bold',
            fontSize: '16px',
            color: '#565656',
            display: 'flex',
            alignItems: 'center'
          }}>
            <FaRegCalendar style={{ marginRight: '5px' }} />
            {formatDateSpan(startDate, endDate)}
          </div>
        ) : <></>
      }
    },
    {
      field: 'trainerNames',
      title: 'Trainers',
      renderer: (data = {}) => {
        return (data.trainerNames?.replace(/,$/, '').replace(/,/, ', '))
      }
    },
    {
      field: 'consultNotesUrl',
      title: <CenteredColumn>Consult Notes</CenteredColumn>,
      renderer: (data = {}) => {
        const { id, consultNotesUrl } = data;
        return consultNotesUrl ? (
          <CenteredColumn>
            <DisplayAndAddMultiConsultNotes eventId={id} consultNotesUrl={consultNotesUrl} isReadOnly={true} isIconOnly={true} />
          </CenteredColumn>
        ) : <></>
      }
    }
  ]

  return (
    <>
      {
        events.length > 0 
        ?
        <Table
          columns={columns}
          data={events}
          mobileMode={isMobileView}
        />
        :
        <div>
          {'No associated events.'}
        </div>
      }
    </>
  )
}